import moment from "moment"
import React, { Component } from "react"
import { Button, Modal } from "react-bootstrap"
import ReviewTimelineTypes from "../../ReviewTypes/ReviewTimelineTypes"
import "./DeleteReviewTimelineItem.css"

interface Props {
    timeLineItem: any
    toggleDelete: Function
    deleteReviewTimelineItem: Function
    contextUserId: number | string
}

class DeleteReviewTimelineItem extends Component<Props, {}> {

    handleDelete = () => {
        let rb: ReviewTimelineTypes = this.props.timeLineItem
        //@ts-ignore
        rb.DeletedDateUTC = moment().format()
        rb.DeletedBy = parseInt(this.props.contextUserId + "")
        this.props.deleteReviewTimelineItem(rb)
        this.props.toggleDelete()

    }

    render() {

        return (
            <div className="DeleteReviewTimelineItem">
                <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="DeleteTimelineModalHeader">
                            <p>Are you sure you want to delete this timeline item?</p>
                        </div>
                    </Modal.Header>
                    <Modal.Footer>
                        <div className="DeleteReviewTimelineItemModalFooter">
                            <Button variant="secondary" onClick={() => this.props.toggleDelete()}>Back</Button>
                            <Button variant="danger" onClick={() => this.handleDelete()}>Delete</Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default DeleteReviewTimelineItem